
import Vue from "vue"
import { mapGetters } from "vuex"
import type { User } from "@/types/api/person"

export default Vue.extend({
  props: {
    item: { type: Object as VuePropType<User>, required: true },
    display: { type: Array as VuePropType<string[]>, default: () => [] },
    hoverable: { type: Boolean, default: true },
  },

  computed: {
    ...mapGetters("user", { me: "user" }),

    withMessage (): boolean { return this.display.includes("message") },
    withDetails (): boolean { return this.display.includes("details") },

    userId (): string {
      return this.item.id || this.item.user?.id || ""
    },

    isMe (): boolean {
      return this.me?.id === this.userId
    },
  },

  methods: {
    openModal () {
      this.$emit("open-modal")
      this.$nuxt.$emit("open-speaker", this.item)
    },
  },
})
